import React from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { alertError, toastInfo, confirm } from "actions/ui";
import { sendUserCommand, clearUserCommand } from "actions/commands";
import {Scrollbar} from "react-scrollbars-custom";

class NotifyUsers extends React.Component {

	constructor(props, context) {
		super(props, context);

		this.state = {
			searchPhrase: '',
			candidates: []
		}

		this.renderCandidate = this.renderCandidate.bind(this);
		this.sendChannelNotifications = this.sendChannelNotifications.bind(this);
	}

	componentDidUpdate(prevProps) {
		const notifyFailure = this.props.sendChannelNotifications !== prevProps.sendChannelNotifications && this.props.sendChannelNotifications && this.props.sendChannelNotifications.success === false;
		const notifySuccess = this.props.sendChannelNotifications !== prevProps.sendChannelNotifications && this.props.sendChannelNotifications && this.props.sendChannelNotifications.success === true;

		if (notifyFailure) {
			this.props.alertError(this.props.sendChannelNotifications.error);
			this.props.clearUserCommand('sendChannelNotifications');
		}

		if (notifySuccess) {
			const channelId = this.props.sendChannelNotifications.result.channelId;

			if (channelId === this.props.channel.id) {
				this.props.clearUserCommand('sendChannelNotifications');
				this.props.toastInfo(this.props.i18n.notificationsSent);
				this.setState( state => ({ candidates: [ ], searchPhrase: '' }));
			}
		}
	}

	componentWillUnmount() {
		if (this.usersSearchTimer) {
			clearTimeout(this.usersSearchTimer);
			this.usersSearchTimer = null;
		}
	}

	searchUsers() {
		if (this.usersSearchTimer) {
			clearTimeout(this.usersSearchTimer);
			this.usersSearchTimer = null;
		}
		if (this.state.searchPhrase) {
			this.usersSearchTimer = setTimeout(function() { this.searchUsersReal(); }.bind(this), 400);
		}
	}

	searchUsersReal() {
		this.props.sendUserCommand('searchUsers', 'searchUsers', { search: this.state.searchPhrase });
	}

	addToNotifyList(e, user) {
		e.preventDefault();
		if (this.state.candidates.find( candidate => candidate.id === user.id)) {
			return;
		}
		this.setState( state => ({ candidates: [...state.candidates, user ]}));
	}

	sendChannelNotifications() {
		this.props.confirm(this.props.i18n.doYouWantNotify, function() {
			this.props.sendUserCommand('sendChannelNotifications', 'sendChannelNotifications', { channelId: this.props.channel.id, users: this.state.candidates.map( user => user.id ) });
		}.bind(this));
	}

	renderCandidate(user) {
		return <span key={ user.id } className="wcFlex wcFlexAlignCenter wcMargin1">
			<img src={user.avatarUrl} className="wcMaxWidth2 wcFunctional" alt="Member picture"/>&nbsp;<span>{user.name}</span>
		</span>
	}

	render() {
		return <React.Fragment>
			<div className="wcFormRow">
				{ this.props.i18n.notificationsIntro }
			</div>
			<div className="wcFormRow">
				<label>{ this.props.i18n.searchUsers }: </label>
				<input
					className={ `wcFormControl` }
					type="text"
					maxLength={ 200 }
					value={ this.state.searchPhrase }
					onChange={ e => this.setState({ searchPhrase: e.target.value }, this.searchUsers )}
				/>
			</div>
			{ this.state.searchPhrase &&
				<div className="wcFormRow">
					<label>{ this.props.i18n.addUsersToList }: </label>
					<div className="wcFormControlBorder wcHeight10 wcPadding1">
						{this.props.users && this.props.users.inProgress && <span className="wcMargin1">{ this.props.i18n.searching }</span> }
						{this.props.users && !this.props.users.inProgress && this.props.users.result.users.length === 0 && <span className="wcMargin1">{ this.props.i18n.noUsers }</span> }
						{this.props.users && this.props.users.result &&
							<Scrollbar>
								{this.props.users.result.users.map( (user, index) => <div
									key={ index }
									className="wcFlex wcFlexAlignCenter wcMargin1">
									<img src={user.avatarUrl} className="wcMaxWidth2 wcFunctional" alt="Member picture"/>&nbsp;<span>{user.name}</span>&nbsp;
									<a href="#" className="wcFunctional" title={ this.props.i18n.addToList } onClick={ e => this.addToNotifyList(e, user) }><span className="wcIcon wcIconPlus" /></a>
								</div>)}
							</Scrollbar>
						}
					</div>
				</div>
			}
			<div className="wcFormRow">
				<label>{ this.props.i18n.sendChannelNotificationsTo }: </label>
				<div className="wcFormControlBorder wcHeight4 wcPadding1">
					{this.state.candidates.length === 0 && <span className="wcMargin1">{ this.props.i18n.addUsers }</span> }
					<Scrollbar>
						<div className="wcFlex wcFlexWrap">
							{ this.state.candidates.map( (entry, index) => this.renderCandidate(entry, index) )}
						</div>
					</Scrollbar>
				</div>
			</div>
			{ this.state.candidates.length > 0 &&
				<div className="wcFormRow">
					<button className="wcButton" onClick={ this.sendChannelNotifications }>{ this.props.i18nBase.send }</button>
				</div>
			}
		</React.Fragment>
	}

}

NotifyUsers.propTypes = {
	channel: PropTypes.object.isRequired,
	configuration: PropTypes.object.isRequired
};

export default connect(
	(state) => ({
		configuration: state.configuration,
		i18nBase: state.configuration.i18n,
		i18n: state.application.i18n,
		users: state.commands.sent.searchUsers,
		sendChannelNotifications: state.commands.sent.sendChannelNotifications
	}),
	{ sendUserCommand, clearUserCommand, alertError, confirm, toastInfo }
)(NotifyUsers);